<template>
	<div class="hero">
		<v-img v-bind="require('@/assets/images/index.jpg')"/>

		<div class="content">
			<div class="items">
				<router-link class="item" :to="{name: 'order'}">
					<div class="icon" v-html="require('@/assets/icons/plus-square-solid.svg')"/>
					<div class="info">
						<div class="title">Bestilling</div>
						<div class="sub">Opret og send en ordre</div>
					</div>
				</router-link>
				<router-link class="item" :to="{name: 'rma'}">
					<div class="icon" v-html="require('@/assets/icons/arrow-alt-square-left.svg')"/>
					<div class="info">
						<div class="title">Reklamation</div>
						<div class="sub">Opret en reklamation</div>
					</div>
				</router-link>
				<div class="item">
					<div class="icon" v-html="require('@/assets/icons/edit.svg')"/>
					<div class="info">
						<div class="title">Åbn eksisterende ordrer</div>
						<div class="sub">Åbn og redigér en eksisterende ordre</div>
					</div>
				</div>
				<div class="item">
					<div class="icon" v-html="require('@/assets/icons/eye.svg')"/>
					<div class="info">
						<div class="title">Gennemse/send ordrer</div>
						<div class="sub">Gennemse en ordre og send den</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {

};
</script>

<style lang="scss" scoped>
.hero {
	position: relative;

	img {
		display: block;
		width: 100%;
		height: em(1038);
		object-fit: cover;
		max-height: 100vh;
		@include res(mobile) {
			max-height: calc(100vh - 62px);
		}
	}

	.content {
		position: absolute;
		top: 0;
		bottom: 0;
		right: 0;
		left: 0;
		display: flex;
		align-items: center;
		justify-content: center;

		.items {
			max-width: 100%;
			@include res(mobile) {
				padding: 0 10px;
			}
			.item {
				background-color: $white1;
				width: em(564);
				height: em(110);
				display: flex;
				align-items: center;
				padding: 0 em(56);
				box-shadow: 0 0 6px 0 rgba(0,0,0,0.04);
				margin-bottom: 0.75em;
				user-select: none;
				max-width: 100%;

				@include res(mobile) {
					height: em(83);
					padding: 0 em(24);
					margin-bottom: 8px;
				}

				&:nth-child(n+3) {
					.icon, .info {
						opacity: 0.15;
					}
				}

				.icon {
					display: inline-flex;
					margin-right: 2em;

					@include res(mobile) {
						margin-right: 1.5em;
					}

					/deep/ svg {
						$s: 1.8em;
						width: $s;
						height: $s;

						path {
							fill: #4A4A4A;
						}
					}
				}

				.info {
					.title {
						font-size: em(16);
						font-weight: 700;
						text-transform: uppercase;
						margin-bottom: 5px;
						@include res(mobile) {
							font-size: em(15);
						}
					}

					.sub {
						font-size: em(12);
						font-weight: 500;
						color: #B1B1B1;
					}
				}
			}
		}
	}
}
</style>
